import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../../../Components/Header/Header.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

import { Badge, Modal, Form, Row, Col, Button } from 'react-bootstrap';
import Trash from "../../../../../assets/images/trash.png";
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';
import Fullsize from "../../../../../assets/images/full-size.svg";

import { withoutRFSToken, withRFSToken } from '../../../../../Services/axios.js';
import { GETDESTINATION, AWBADD, AWBMSG, GETSHC, GETOWNERCODE, ADDAWB } from '../../../../../Utils/conts.js';
import { toast } from 'react-toastify';

const AddAWB = ({ isModal, closeModal, assignData, reloadGrid, isModalEdit }) => {

    const isMounted = useRef(false);
    const [getDestination, setGetDestination] = useState([]);
    const [getShc, setGetShc] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);

    const fetchSHC = async () => {
        try {

            const res = await withRFSToken.post(GETSHC, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.code,
                        label: item.code,
                    })) : [];
                    setGetShc(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDestination = async () => {
        try {

            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchOwnerCode = async () => {
        try {

            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA
                    })) : [];
                    setGetOwnerCode(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        // Call the fetchData function to fetch data from the API
        if (isMounted.current) return;
        fetchSHC();
        fetchDestination();
        fetchOwnerCode();
        isMounted.current = true;
    }, []);

    const [formData, setFormData] = useState(
        [
            {
                id: '1',
                airway_bill: '',
                pieces: '',
                weight: '',
                volume: '',
                shc: '',
                commodity: '',
                flight_code: '',
                flight_number: '',
                flight_date: '',
                origin: '',
                destination: ''
            }
        ]
    );
    console.log('assignData', assignData);

    useEffect(() => {
        console.log('Adata', assignData);
        if (isModalEdit) {
            setFormData([assignData]);
        }
    }, [])

    const addULDStack = () => {
        const lastId = formData.length > 0 ? parseInt(formData[formData.length - 1].id) : 0;
        const newId = (lastId + 1).toString();
        setFormData(prevFormData => [
            ...prevFormData,
            {
                id: newId,
                airway_bill: '',
                pieces: '',
                weight: '',
                volume: '',
                shc: [],
                flight_code: '',
                flight_number: '',
                flight_date: '',
                origin: '',
                destination: ''
            }
        ]);
    };
    const removeULDStack = (uldInfoId) => {
        setFormData(prevFormData => prevFormData.filter(entry => entry.id !== uldInfoId));
    };

    const handleULDInputChange = (uldInfoId, fieldName, value) => {
        if (fieldName === 'airway_bill') {
            value = handleChange(value);
        }
        setFormData(prevFormData => prevFormData.map(entry => {
            if (entry.id === uldInfoId) {
                return { ...entry, [fieldName]: value };
            }
            return entry;
        }));
    };
    const handleChange = (value) => {
        value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
        let formattedValue = '';

        // Add a hyphen after the third character
        if (value.length > 3) {
            formattedValue += value.substr(0, 3) + '-';
            value = value.substr(3);
        }

        // Add a space after the eighth character
        if (value.length > 4) {
            formattedValue += value.substr(0, 4) + ' ';
            value = value.substr(4);
        }

        formattedValue += value;
        return formattedValue.substr(0, 13);
    };

    const validateFormData = () => {
        let isValid = true;

        for (let i = 0; i < formData.length; i++) {
            const uld = formData[i];
            if (!uld.airway_bill) {
                toast.error('Please set Airway Bill');
                isValid = false;
                break;
            }
            if (!uld.pieces) {
                toast.error('Please set Pieces');
                isValid = false;
                break;
            }
            // if (!uld.flight_code) {
            //     toast.error('Please set Flight Code');
            //     isValid = false;
            //     break;
            // }
            // if (!uld.flight_number) {
            //     toast.error('Please set Flight Number');
            //     isValid = false;
            //     break;
            // }
            // if (!uld.flight_date) {
            //     toast.error('Please set Flight Date');
            //     isValid = false;
            //     break;
            // }
            if (!uld.origin) {
                toast.error('Please set Origin');
                isValid = false;
                break;
            }
            if (!uld.destination) {
                toast.error('Please set Destination');
                isValid = false;
                break;
            }
        }
        return isValid;
    };

    const handleSave = async () => {
        if (validateFormData()) {
            // const transformedData = {
            //     ...formData,
            //     asset_type: formData.asset_type ? 'L' : 'O',
            //     uldInfo: formData.uldInfo.map(stack => ({
            //         ...stack,
            //         asset_type: stack.asset_type ? 'L' : 'O'
            //     }))
            // };
            // console.log('Saving data:', transformedData);
            let endPoint;
            let payload;
            if (isModal) {
                endPoint = ADDAWB
                payload = {
                    AWB: formData,
                    BTS: {
                        bookingtruck_date_id: assignData.bookingtruck_date_id,
                        date: assignData.departure_date,
                    }
                }
            } else {
                endPoint = AWBADD
                payload = {
                    awbs: formData
                }
            }

            try {
                const res = await withRFSToken.post(endPoint, payload);
                if (res.data.response_code == 200) {
                    toast.success('New AWB Saved')
                    if (isModal) {
                        closeModal()
                        reloadGrid();
                    } else if (isModalEdit) {
                        closeModal()
                        reloadGrid();
                    } else {
                        const innerData = res.data.response_data;
                        window.location.href = '/AWBManager';
                    }

                } else {
                    toast.error(res.data.response_msg);
                }
                // .then(function (res) {

                // });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    };

    const [showModal, setShowModal] = useState(false);
    const handleModalClose = () => { setShowModal(false); };
    const handleModalOpen = () => {
        setShowModal(true);
    };
    const handleConfirmation = (confirm) => {
        if (confirm) {
            if (isModal || isModalEdit) {
                closeModal();
            } else {
                setShowModal(false);
                window.location.href = '/AWBManager'
            }

        } else {
            setShowModal(false);
        }
    };

    const [processText, setProcessText] = useState('');

    const handleTextareaChange = (e) => {
        setProcessText(e.target.value);
    };
    const handleProcessButtonClick = async () => {
        // Process the data in processText
        console.log('Processing AWB:', processText);
        try {
            const res = await withRFSToken.post(AWBMSG, { msg_type: 'fsu', message: processText });
            if (res.data.response_code == 200) {
                toast.success('AWB processed');
                const processedData = res.data.response_data;
                // console.log("🚀 ~ handleProcessButtonClick ~ processedData:", processedData)
                const lastRow = formData[formData.length - 1];
                const isLastRowEmpty = Object.values(lastRow).every(
                    value => value === '' || value === '1'
                );
                const lastId = formData.length > 0 ? parseInt(formData[formData.length - 1].id) : 0;
                let nextId = lastId + 1;

                const apiRowsWithDynamicIds = processedData.map((row) => {
                    let airwayBill = row.airway_bill || '';

                    // Check if there is a '-' and add a space after the 4th character after '-'
                    if (airwayBill.includes('-')) {
                        const parts = airwayBill.split('-');
                        if (parts[1] && parts[1].length > 4) {
                            parts[1] = parts[1].slice(0, 4) + ' ' + parts[1].slice(4);
                        }
                        airwayBill = parts.join('-');
                    }
                    return {
                        id: (nextId++).toString(),
                        airway_bill: airwayBill || '',
                        pieces: row.pieces || '',
                        weight: row.weight || '',
                        volume: row.volume || '',
                        shc: row.shc || '',
                        flight_number: row.flight_number || '',
                        origin: row.origin || '',
                        destination: row.destination || ''
                    };
                });

                // Merge the new API rows with the manually added rows
                // setFormData(prevFormData => [
                //     ...prevFormData,
                //     ...apiRowsWithDynamicIds
                // ]);
                setFormData(prevFormData => {
                    if (isLastRowEmpty) {
                        return [...prevFormData.slice(0, -1), ...apiRowsWithDynamicIds];
                    } else {
                        return [...prevFormData, ...apiRowsWithDynamicIds];
                    }
                });

                if (showProcess) {
                    setShowProcess(false);
                }
                setProcessText('');

            } else {
                toast.error(res.data.response_msg);
            }
            // .then(function (res) {

            // });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const [showProcess, setShowProcess] = useState(false);
    const handleCloseProcess = () => { setShowProcess(false); };
    const handleFullsizeClick = (event) => {
        event.preventDefault();
        setShowProcess(true);
    };



    console.log('0123', formData);
    return (
        <>
            <div className="">
                {isModal || isModalEdit ? '' : <Header logo_url='/AWBManager' />}
                <div className='main-panel'>
                    {isModal || isModalEdit ? '' : (<Link to="/AWBManager" className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>)}
                    <Row className='mt-3'>
                        <Col lg={isModalEdit ? '12' : "9"}>
                            <div className='flbg add_awb'>
                                <div className='d-flex justify-content-between adds_top'>
                                    <h3>Add AWB</h3>
                                    <span>Total AWB<Badge>{formData.length}</Badge></span>
                                </div>
                                <div className='stck_middle mt-2'>
                                    {formData && formData.map((section, index) => {
                                        return (
                                            <div className='d-flex mb-3 sub_add' key={index}>
                                                {/* {console.log('100', section)} */}
                                                <div className='saairbill'>
                                                    <Form.Label>Airway Bill <span>*</span></Form.Label>
                                                    <Form.Control type="text"
                                                        name='airway_bill'
                                                        value={section.airway_bill || ''}
                                                        maxLength={13}
                                                        // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                                                        onChange={(e) => handleULDInputChange(section.id, 'airway_bill', e.target.value)} />
                                                </div>
                                                <div className='sapiec'>
                                                    <Form.Label>Pieces <span>*</span></Form.Label>
                                                    <Form.Control type="text"
                                                        name='pieces'
                                                        value={section.pieces || ''}
                                                        maxLength='6' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 6); }}
                                                        onChange={(e) => handleULDInputChange(section.id, 'pieces', e.target.value)} />
                                                </div>
                                                <div className='saweight'>
                                                    <Form.Label>Weight</Form.Label>
                                                    <Form.Control type="text"
                                                        name='weight'
                                                        value={section.weight || ''}
                                                        maxLength='5'
                                                        placeholder='0.00'
                                                        // onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                                                        // onChange={(e) => handleULDInputChange(section.id, 'weight', e.target.value)}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const formattedValue = value.match(/^\d*\.?\d{0,2}$/) ? value : section.weight || ''; // Allow up to 2 decimal places
                                                            handleULDInputChange(section.id, 'weight', formattedValue);
                                                        }}
                                                    />
                                                </div>
                                                <div className='savolume'>
                                                    <Form.Label>Volume</Form.Label>
                                                    <Form.Control type="text"
                                                        name='volume'
                                                        value={section.volume || ''}
                                                        placeholder='0.00'
                                                        // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                                                        // onChange={(e) => handleULDInputChange(section.id, 'volume', e.target.value)}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const formattedValue = value.match(/^\d*\.?\d{0,2}$/) ? value : section.volume || ''; // Allow up to 2 decimal places
                                                            handleULDInputChange(section.id, 'volume', formattedValue);
                                                        }}
                                                    />
                                                </div>

                                                <div className='saorigin'>
                                                    <Form.Label>Origin <span>*</span></Form.Label>
                                                    <Select
                                                        options={getDestination}
                                                        onChange={(e) => handleULDInputChange(section.id, 'origin', e.value)}
                                                        placeholder="Origin"
                                                        className='autoslct'
                                                        name="origin"
                                                        value={getDestination.find(option => option.value === section.origin) || ''}
                                                    />
                                                </div>
                                                <div className='sadesti'>
                                                    <Form.Label>Destination <span>*</span></Form.Label>
                                                    <Select
                                                        options={getDestination}
                                                        onChange={(e) => handleULDInputChange(section.id, 'destination', e.value)}
                                                        placeholder="Destination"
                                                        className='autoslct'
                                                        name="destination"
                                                        value={getDestination.find(option => option.value === section.destination) || ''}
                                                    />
                                                </div>

                                                <div className='sashc'>
                                                    <Form.Label>SHC</Form.Label>
                                                    <MultiSelect
                                                        options={getShc}
                                                        value={getShc.filter(option => section.shc?.includes(option.value)) || ''}
                                                        onChange={(selectedOptions) => {
                                                            const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                                            handleULDInputChange(section.id, 'shc', selectedValues);
                                                        }}
                                                        labelledBy="Select "
                                                        className='multiselect autoslct'
                                                        name="shc"
                                                    />
                                                    {/* <Select
                                                        options={getShc}
                                                        // onChange={(e) => handleULDInputChange(section.id, 'shc', e.value)}
                                                        onChange={(selectedOptions) => {
                                                            const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                                            handleULDInputChange(section.id, 'shc', selectedValues);
                                                        }}
                                                        placeholder="SHC"
                                                        className='autoslct'
                                                        name="shc"
                                                        isMulti
                                                        value={getShc.filter(option => section.shc.includes(option.value))}
                                                    // value={getShc.find(option => option.value === section.shc) || ''}
                                                    /> */}
                                                </div>
                                                <div className='sacommodity'>
                                                    <Form.Label>Commodity</Form.Label>
                                                    <Form.Control type="text"
                                                        name='commodity'
                                                        value={section.commodity || ''}
                                                        // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
                                                        onChange={(e) => handleULDInputChange(section.id, 'commodity', e.target.value)} />
                                                </div>
                                                {/* <div className='saflight'>
                                                    <Form.Label>Flight Number <span>*</span></Form.Label>
                                                    <div className='d-flex align-items-center'>
                                                        <div className='flightdrp'>
                                                            <Select
                                                                options={getOwnerCodes}
                                                                onChange={(e) => handleULDInputChange(section.id, 'flight_code', e.value)}
                                                                placeholder="Flight"
                                                                className='autoslct'
                                                                name="flight_code"
                                                                value={getOwnerCodes.find(option => option.value === section.flight_code) || ''}
                                                            />
                                                        </div>
                                                        <div className='space'>-</div>
                                                        <div className='flightn'>
                                                            <Form.Control type="text"
                                                                name='flight_number'
                                                                value={section.flight_number || ''}
                                                                maxLength='8'
                                                                // onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                                onChange={(e) => handleULDInputChange(section.id, 'flight_number', e.target.value)} />
                                                        </div>

                                                    </div>


                                                </div>
                                                <div className='flight_date'>
                                                    <Form.Group>
                                                        <Form.Label>Flight Date <span>*</span></Form.Label>
                                                        <Form.Control
                                                            type="datetime-local"
                                                            name='flight_date'
                                                            onChange={(e) => handleULDInputChange(section.id, 'flight_date', e.target.value)}
                                                            value={section.flight_date}
                                                        />
                                                    </Form.Group>
                                                </div> */}
                                                
                                                <div className='imag_trash'>
                                                    {formData.length > 1 && (
                                                        <img src={Trash} alt='' onClick={() => removeULDStack(section.id)} />
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    })}
                                    {!isModalEdit && <div className='text-end'><Button variant="primary" className='stk_add' onClick={addULDStack}> <FontAwesomeIcon icon={faPlus} />Add AWB</Button></div>}
                                </div>
                                <div className='text-center mt-5'>
                                    <Button variant="light" className='stk_cancel' onClick={handleModalOpen}>CANCEL</Button>
                                    <Button variant="primary" className='stk_save' onClick={handleSave}>SAVE</Button>
                                </div>
                            </div>
                        </Col>
                        {!isModalEdit &&
                            <Col lg="3">
                                <div className='flbg add_awb'>
                                    <div className='d-flex justify-content-between charter_top '>
                                        <h3>Automated FSU processing</h3>
                                        <a href='#' onClick={handleFullsizeClick}><img src={Fullsize} /> </a>
                                    </div>

                                    <div className='au_proses'>
                                        <Form.Group >
                                            <Form.Control
                                                as="textarea" name='process' aria-label="With textarea" type="text" style={{ resize: 'none' }}
                                                value={processText}
                                                onChange={handleTextareaChange}
                                            />
                                        </Form.Group>
                                        <div className='text-center mt-3'>
                                            <Button variant="primary" className='process_btn' onClick={handleProcessButtonClick}> Process FSU </Button></div>
                                    </div>
                                </div>
                            </Col>
                        }
                    </Row>
                </div>
            </div>
            <Modal show={showProcess} className='addfrom' onHide={handleCloseProcess} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Automated FSU processing</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='au_proses'>
                        <Form.Group>
                            <Form.Control
                                as="textarea"
                                name='process'
                                aria-label="With textarea"
                                type="text"
                                style={{ resize: 'none' }}
                                value={processText}
                                onChange={handleTextareaChange}
                            />
                        </Form.Group>
                        <div className='text-center mt-3 mb-3'>
                            <Button variant="primary" className='process_btn' onClick={handleProcessButtonClick}> Process FSU </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>All changes will be destroyed.</h3>
                    <p>If you proceed with the change, all data in this section will be removed.
                        Are you sure you want to continue?</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                            No
                        </Button>
                        <Button variant="primary" onClick={() => handleConfirmation(true)}>
                            Yes
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AddAWB